<div class="container">
    <div *ngFor="let item of arr">
        <pre>
            {{item|json}}
        </pre>
        <button mat-raised-button color="primary" (click)="triggerToSendNot(item)">Trigger to send Notification</button>
        <hr>
    </div>
</div>